import base from "../../../base";

export default async function fetchTreePlayerCount(treeID) {
	const treePlayerCount = base.fetch(`trees/${treeID}/treeInfo/seats`, { context: this });
	return treePlayerCount;
}
